import { makeVar } from "@apollo/client";

export const loggedIn = makeVar(false);
export const username = makeVar("");
export const accessToken = makeVar("");
export const refreshToken = makeVar("");
export const expiryTime = makeVar(0);
export const refreshAction = makeVar();
